module.exports = __webpack_public_path__ + "img/blog_mobile.c0f58332.svg";